import { render } from "./Emailpage.vue?vue&type=template&id=db0b7898&scoped=true&ts=true"
import script from "./Emailpage.vue?vue&type=script&lang=ts"
export * from "./Emailpage.vue?vue&type=script&lang=ts"

import "./Emailpage.vue?vue&type=style&index=0&id=db0b7898&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0b7898"]])

export default __exports__